

import React from 'react';
 
import ReactDOM from 'react-dom';
//import { Select,Cascader } from 'element-react';

import { Select, Cascader, Radio, Checkbox, Image } from '@jd/find-react';

 




// import FsProvince from './mobile/FsProvince.js'
import KeeVue from '../base/KeeVue.js'
const { Option } = Select;
export default class FsSelect extends KeeVue {
  constructor(props) {
         super(props);

			var selectCompId=this.getRandString();
			this.state =  {
				selectCompId:selectCompId,
				options: [],
				optionstring:"",
				lastValue: '',
				selectValue: '',
				selectTitle:'',
				
				cascaderValue: [],
				cascaderValueTemp: [],
				propsConfig: {
					value: 'id',
					label: 'text',
					children: 'children',
					expandTrigger: 'hover' 
				},
				listOptionsArray: [],
				value:null,
				values: [],
			}
		
}

		componentDidMount(){
			this.registComponent();
			console.log("select:jiazai select");
			
			if(this.props.component.name=='fs-select')
			{
				if(this.props.component.value=="[]")
				{
					this.props.component.value="";
				}
			}
				
			this.state.value=this.props.component.value;
			
			
			
			if(this.props.component.name=='fs-select')
			{
				//alert("this.props.component.value:"+this.props.component.value+this.props.component.cp.defaultValue);
				
				if(!this.props.component.value)
				{
					
					this.state.selectValue = this.props.component.cp.defaultValue;
					 
					this.state.value=this.props.component.cp.defaultValue;
				}
				else
				{
					this.state.selectValue = this.props.component.value;
					 
					this.state.value=this.props.component.value;
				}
				
			}
			
			
			
			this.init();
			
			
			//console.log("首次更新时加载数据")
		}

			visibleChange=(v)=>{
				// if(v)
				// {
				// 	this.$refs[this.state.selectCompId].focus();
				// }
				// else
				// {
				// 	this.$refs[this.state.selectCompId].blur();
				// }
			} 
			check=(item)=> {
				//console.log("选中的多选或单元框：");
				//console.log(JSON.stringify(item));
				if(this.props.component.name === "fs-checkbox") {
					item.xuanzhong = !item.xuanzhong;
					item.id = this.getRandString();
				} else {
					for(var i = 0; i < this.state.options.length; i++) {
						this.state.options[i].xuanzhong = false;
						this.state.options[i].id = this.getRandString();
					}
					item.xuanzhong = true;
					this.state.selectValue = item.value;
					this.valueChange(item.value);
					return ;
				}
				this.valueChange(item.value);
			} 
			clearChild=(nodes)=>
			{
				if(nodes)
				for(var i=0;i<nodes.length;i++)
				{
					nodes[i].label = nodes[i].text;
					nodes[i].value = nodes[i].id;
					if(nodes[i].children&&nodes[i].children.length>0)
					{
						this.clearChild(nodes[i].children);
					}
					else
					{
						// 不能只为null，否则会报错！
						//nodes[i].children = null;
						
						delete nodes[i].children;
					}
				}
			} 
			init=()=> {
				var that = this;
				
				this.listOptions = this.props.component.cp.listOptions;
				
				if(this.props.component !== null) {
					this.onEvent(this.props.component.id + ".reload",  (data)=> {
						 
						 
						// alert("默认值："+this.props.component.cp.defaultValue+" debug:"+this.props.debug)
						 
						 this.props.component.value=null;
					
						
						if(this.props.component.name === "fs-select" || this.props.component.name === "fs-radio" || this.props.component.name === "fs-checkbox") {
						 
							
							
							that.state.options = data;
							console.log("reload后999999999999 值改变："+this.props.component.cp.defaultValue);
							
							
							if(this.props.component.name=='fs-checkbox')
							{
							 
								// if(!this.props.component.value&&this.props.component.cp.defaultValue.indexOf("[")==0)
								// {
								// 	this.state.values = JSON.parse(this.props.component.cp.defaultValue);
								// 	that.initData(data);
								// }
								
								var array = [];
								
								if(this.props.component.cp.defaultValue) 
								 {
									 array = this.props.component.cp.defaultValue.split(",");
								 }
								
								 
								
								
								
								this.state.values = array;
								this.initData(data);
								
								
							}
							else
							{ 
								if(!this.props.component.value)
								{
									that.state.selectValue = this.props.component.cp.defaultValue;
									 
									this.state.value=this.props.component.cp.defaultValue;
								} 
								
								
								console.log("reload后0 值改变："+that.state.selectValue);
								that.initData(data);
								
							}
							
							
							
						}
						if(this.props.component.name !== "fs-cascader") {
							var exists = false;
							for(var i = 0; i < that.state.options.length; i++) {
								if(that.state.options[i].value === that.props.component.value) {
									exists = true;
									break;
								}
							}
							if(!exists) {
								that.props.component.value = "";
							}
						}
					})
				}
				
				if(this.props.component.name === "fs-select" || this.props.component.name === "fs-radio" || this.props.component.name === "fs-checkbox" || this.props.component.name === "fs-cascading") {
					// console.log("comp:"+ this.props.component.cp.dsType+" ID:"+this.props.component.id+" type:"+this.props.component.name);
					
					if(window.isReport)
					{
						this.props.component.cp.dsType = "listOptions";
					}
					
					if(this.props.component.cp.dsType === "listOptions") {
						if(typeof this.props.component.cp.listOptions  ) {
							if(typeof this.props.component.cp.listOptions === 'string')
							try{
								this.listOptionsArray = JSON.parse(this.props.component.cp.listOptions);
								}catch(e){
									console.log(e);
								}
							if(this.state.options !== null && this.state.options.length > 0) {
								console.log("select:this.state.options");
								that.listOptionsArray = this.state.options;
							}
							
							console.log("select:this.listOptionsArray");
							that.initData(this.listOptionsArray);
						}
						return ;
					}
					if(this.props.component.cp.dsType === "dict"&&this.props.component.cp.dict!=="") {
						if(!this.dictData)
						{
							this.doRequest("/sysDict/getOptions?name=" + this.props.component.cp.dict, function(ret) {
								that.dictData = ret;
								that.initData(ret);
							});
						}
						else
						{
							this.initData(that.dictData );
						}
						
						return ;
					}
					//if(!this.url)
					{
						this.url = this.props.component.cp.url;
					}
					 
					if(this.props.component.cp.dsType === "url"&&this.url!=="") {
						if(!this.urlData)
						{
							this.doRequest(this.url, (ret)=> {
								console.log("采用url方式加载："+this.url);
								this.urlData = ret;
								that.initData(ret);
							})
						}
						else
						{
							that.initData(this.urlData);
						}
						
						return ;
					}
					{
						var newOptions = [];
						for(var i=0;this.props.component.cp.options&&i<this.props.component.cp.options.length;i++)
						{
							var newItem = {};
							this.props.component.cp.options[i].component=null;
							if(!this.isNotBlank(this.props.component.cp.options[i].value))
							{
								this.props.component.cp.options[i].value = this.props.component.cp.options[i].title;
							}
							this.props.component.cp.options[i].id = this.props.component.cp.options[i].cid;
							newItem.id = this.props.component.cp.options[i].id ;
							newItem.title = this.props.component.cp.options[i].title ;
							newItem.value = this.props.component.cp.options[i].value ;
							newOptions.push(newItem);
						}
						that.initData(newOptions);
					}
				}
				if(this.props.component.name === "fs-cascader") {
					this.doRequest(this.props.component.cp.url, function(ret) {
						
						that.clearChild(ret);
						that.initData(ret);
					})
				}
				
			} 
			getData=()=> {
			 let v = this.props.component.value;
			 
			 if(typeof v == "undefined"||this.props.component.value==[])
			 {
			 	return ""
			 }
			 
			 if(typeof this.props.component.value==="string")
			 { 
			 	//alert("fanhuishi："+this.props.component.value); 
			 	
			 	if(this.props.component.value.indexOf("[")==0 )
			 	{
			 		let arry = JSON.parse(v);
			 		
			 		var temp = "";
			 		for(let i=0;i<arry.length;i++)
			 		{
			 			if(temp)
			 			{
			 				temp+=",";
			 			}
			 			temp+=arry[i];
			 		}
			 		return temp; 
			 		 
			 	}
			 	 
			 	 return this.props.component.value;
			 	  
			 }
			 else
			 {
			 	if(this.props.component.value&&this.props.component.value!==[]&& this.props.component.cp.multiple===true)
			 	{
			 		var temp = "";
			 		for(var i=0;i<this.props.component.value.length;i++)
			 		{
			 			if(temp)
			 			{
			 				temp+=",";
			 			}
			 			temp+=this.props.component.value[i];
			 		}
			 		return temp;
			 	}
			 }
			 if(this.props.component.value==[]||typeof this.props.component.value == "undefined")
			 {
			 	this.props.component.value = "";
			 	return this.props.component.value;
			 }
			 if(!this.props.component.value)
			 {
			 	return "";
			 }
			 return this.props.component.value;
			} 
			initData=(ret)=> {
				//alert("leixing:"+this.props.component.name+":"+this.props.component.value);
				if(ret)
				{
					this.ret = ret;
				}
				else{
					ret = this.ret;
					
				}
				if(!ret)
				{
					// setTimeout(()=>{
					// 	if(!this.initTimes)
					// 	{
					// 		this.initTimes = 0;
					// 	}
					// 	this.initTimes++;
					// 	if(this.initTimes<100)
					// 	{
					// 		this.initData(ret);
					// 	}
						
					// },100)
					return ;
				}
				
			
			 
				
				var that = this;
				
				
				if(this.props.component.name=='fs-checkbox')
				{
					 
					if(this.props.component.value&&this.props.component.value.indexOf("[")==0)
					{
						this.state.values = JSON.parse(this.props.component.value);
						this.checkBoxValueChange(this.state.values);
						
					}
				 			
					if(!this.props.component.value)
					{
						if(this.props.component.cp.defaultValue&&this.props.component.cp.defaultValue.indexOf("[")==0)
							
						{this.state.values = JSON.parse(this.props.component.cp.defaultValue);
					
						this.checkBoxValueChange(this.state.values);
						} 
					} 
				}
				
				
				
				if(this.props.component.name === "fs-checkbox") {
					if(ret)
					{
						ret.map((obj,index)=>{
							obj.id = this.getRandString();
							obj.label = obj.title;
						})
					}
					
				that.state.selectValue = that.props.component.value;
					that.state.selectTitle = "";
					this.each(ret, function(i, obj) {
						if(obj)
						{
							obj.label = obj.title;
							if((","+that.props.component.value + ",").indexOf(","+(obj.value) + ",") !== -1) {
							obj.xuanzhong = true;
							that.state.selectTitle +=obj.title+" ";
							obj.id = that.getRandString();
							} else {
								obj.xuanzhong = false;
							}
						}
					})
				}
				
				//alert("leixing2222:"+this.props.component.name+":"+this.props.component.value);
				
				if(this.props.component.name === "fs-radio"||this.props.component.name === "fs-select") {
					
					if(ret)
					{
						ret.map((obj,index)=>{
							obj.id = this.getRandString();
							obj.label = obj.title;
						})
					}
					
						//console.log("radio 和 select 初始化数据：that.props.component.value="+that.props.component.value);
						if(that.props.component.cp.multiple===true)
						{
							that.state.selectValue = [];
							that.state.selectTitle = "";
							if(that.props.component.value)
							{
								var v = ","+that.props.component.value+",";
								this.each(ret, function(i, obj) {
								if(obj)
								{
								if( v.indexOf(","+(obj.value) + ",") !== -1   ) {
									that.state.selectValue.push(obj.value);
									if(that.state.selectTitle)
									{
										that.state.selectTitle+=",";
									}
									that.state.selectTitle += obj.title;
									obj.label = obj.title;
									obj.xuanzhong = true;
									obj.id = that.getRandString();
								} else {
									obj.xuanzhong = false;
									obj.id = that.getRandString();
								}
								}
								})
							}
						}
						else
						{
						// that.state.selectValue = that.props.component.value;
						var exists = false;
						this.each(ret, function(i, obj) {
							if(obj)
							{
								obj.label = obj.title;
								
							if( obj.value === that.state.selectValue) {
								that.state.selectValue = obj.value;
								that.state.selectTitle = obj.title;
								obj.xuanzhong = true;
								obj.id = that.getRandString();
								obj.label = obj.title;
								exists = true;
								// if(that.props.component)
								// {
								// 	that.props.component.value = obj.value;
								// }
								
								console.log("xuanzhong moren zhi:值改变"+obj.value+obj.xuanzhong);
							} else {
								obj.xuanzhong = false;
								obj.id = that.getRandString();
							}
							}
						})
						
						if(!exists)
						{
							that.state.selectValue = "";
						}
						
						if(!this.props.component.value)
						{
							that.state.selectValue = this.props.component.cp.defaultValue;
							 
							this.state.value=this.props.component.cp.defaultValue;
						}
						
						
						
					}
				}
				if(this.props.component.name === "fs-cascader") {
					//setTimeout(()=> 
					//alert("that.props.component.value:"+that.props.component.value);
					//
						if(that.isNotBlank(that.props.component.value)) {
							console.log("级联初始化加载 " + that.props.component.value);
							that.state.cascaderValueTemp = [];
							that.state.selectTitle = "";
							that.state.selectTitle = that.findCascaderValue(ret, that.props.component.value);
							that.state.cascaderValue = that.state.cascaderValueTemp.reverse();
							console.log("级联初始化加载2： " + that.state.cascaderValue);
						} else {
							that.state.cascaderValue =[];
							that.state.selectTitle = "";
						}
					//
				}
				if(ret&&ret.length>0)
				{
					 
					that.state.options = [...ret];
				}
				else
				{
					that.state.options=[];
				}
				this.state.optionstring = JSON.stringify(that.state.options);
				
				//console.log("optionstring:"+this.state.optionstring);
				
				//this.setState(this.state);
				
				this.refresh();
				
				
			} 
			findCascaderValue=(options, targetId)=> {
				var that = this;
				if(options)
				{
					for(var i = 0; i < options.length; i++) {
						
						var childPath = "";
						if(options[i].id === targetId) {
							this.state.cascaderValueTemp.push(options[i].id);
							childPath=options[i].text  ;
							return childPath;
						} else
						if(options[i].children) {
							childPath = this.findCascaderValue(options[i].children, targetId);
							if(childPath) {
								 this.state.cascaderValueTemp.push(options[i].id);
								 
									return options[i].text+"/"+childPath;
								 
							}
						}
					}
				}
				
				return null;
			} 
			valueChange=(newValue,option)=> {
				var that = this;
				
				if(typeof newValue =="undefined")
				{
					newValue = "";
				}
				
				//alert("changegegege")
				 
				this.state.selectValue = newValue;
				console.log(this.props.component.name+" 值改变："+ JSON.stringify(newValue));
				if(this.props.component.name===null||this.props.component.name===''||this.props.component.name==='fs-select'||this.props.component.name==='fs-radio')
				{
					that.props.component.value = this.state.selectValue;
					if(that.props.component.cp.multiple===true)
					{
						if(this.state.selectValue.length===0)
						{
							that.props.component.value = "";
						}
					}
					this.setVueAttr(that.props.po,this.props.component.cp.field , newValue);
					 
					// this.$emit("change",this.state.selectValue);
					this.sendPageEvent("change",this.state.selectValue);
					console.log("fs-select 值改变2222："+ JSON.stringify(that.props.component.value));
				 
					this.setState(this.state);
					return ;
				}
				var arry = that.state.cascaderValue;
				if(this.props.component.name === "fs-cascader" || this.props.component.name === "fs-cascading") {
					// if(arry.length > 1) {
					// 	for(var i = 0; i < that.state.options.length; i++) {
					// 		if(that.state.options[i].id === arry[0] || that.state.options[i].value === arry[0]) {
					// 			if(that.state.options[i].children !== null && that.state.options[i].children.length > 0) {
					// 				break;
					// 			} else {
					// 				that.state.cascaderValue = [arry[0]];
					// 				break;
					// 			}
					// 		}
					// 	}
					// }
					
					if(window.isMobile)
					{
						newValue = newValue.split(",");
						that.state.cascaderValue = newValue;
						
						that.props.component.value = newValue[newValue.length-1]; 
						// this.$emit("change",that.props.component.value);
						this.sendPageEvent("change",that.props.component.value);
						
						console.log("当前值："+that.props.component.value)
					}
					else
					{
						that.state.cascaderValue = newValue;
						if (this.props.component.name === "fs-cascader") {
							if(that.state.cascaderValue.length > 0) {
								that.props.component.value = that.state.cascaderValue[that.state.cascaderValue.length - 1].replace(/"/g, "");
							}
						} else if (this.props.component.name === "fs-cascading") {
							that.props.component.value = that.state.cascaderValue.join('/');
						} else
						{
							that.props.component.value = "";
						}
						
						// this.$emit("change",that.props.component.value);
						this.sendPageEvent("change",that.props.component.value);
						
						console.log("当前值："+that.props.component.value)
					}
					
					
				} else {
					if(this.props.component.name === "fs-checkbox") {
						var ids = "";
						for(var i = 0; i < that.state.options.length; i++) {
							if(that.state.options[i].xuanzhong&&that.state.options[i].xuanzhong!="false") {
								if(ids !== "")
									ids += ",";
								ids += that.state.options[i].value;
							}
						}
						that.props.component.value = ids;
					} else {
						for(var i = 0; i < that.state.options.length; i++) {
							if(ids !== "")
								ids += ",";
							if(that.state.options[i].xuanzhong&&that.state.options[i].xuanzhong!="false")
								that.props.component.value = that.state.options[i].value;
						}
					}
				}
				
				if(this.props.po)
				{
					this.setVueAttr(this.props.po, that.props.component.cp.field, that.props.component.value);
				}
				
				this.refresh();
				 
				// this.sendEvent("change");
				this.sendPageEvent("change",that.props.component.value);
			}
			
			componentWillReceiveProps(nextProps){
				
				//console.log("will props 值改变："+this.props.component.value+"--"+nextProps.component.name)
				
				if(nextProps.component.name=='fs-radio'||nextProps.component.name=='fs-select')
				{
					
					if(this.state.selectValue!==nextProps.component.value||this.state.value!==nextProps.component.value||this.listOptions!=nextProps.component.cp.listOptions)
					{
						console.log("init 值改变："+nextProps.component.value)
						this.state.value = nextProps.component.value;
						this.state.selectValue =  nextProps.component.value;
						setTimeout(()=>{
							this.init()
						},50);
						//this.init();
					}
					// else
					 {
						
						// console.log("fs-select 不需要更新")
					 }
				}
				if(nextProps.component.name=='fs-checkbox' )
				{
					var array = [];
					if(nextProps.component.value)
					{
						
					}
					
					if( nextProps.component.value&&nextProps.component.value.indexOf("[")==0)
					{
						array = JSON.parse(nextProps.component.value);
					}
					else
					{
						array = nextProps.component.value.split(",");
					}
					
					
					// if(this.props.component.value&&this.props.component.value.indexOf("[")==0)
					// {
					// 	this.state.values = JSON.parse(this.props.component.value);
					// 	this.initData(null);
					// }
					// else
					// {
					// 	if(this.props.component.cp.defaultValue&&this.props.component.cp.defaultValue.indexOf("[")==0)
							
					// 	{this.state.values = JSON.parse(this.props.component.cp.defaultValue);
					// 	} 
					// 	this.initData(null);
					// } 
					
					
					 
					if(JSON.stringify(this.state.values)!=JSON.stringify(array))
					{
						this.state.values = array;
						this.initData(null);
					}
					 else
					 {
						 //console.log("fs-checkbox 不需要更新")
					 }
				}
				
				if(nextProps.component.name === 'fs-cascader'  )
				{
					// var array = [];
					// if(nextProps.component.value)
					// {
					// 	array = nextProps.component.value.split(",");
					// }
					 
				 
						this.initData(null);
					 
				}
				
				
				
				
			}
			
			renderFsSelect(){
				
				//console.log("render:值改变："+ this.state.selectValue);
				//console.log("render:值改变："+ JSON.stringify( this.state.options));
				var realSelectValue = this.state.selectValue;
				
				if(this.props.component.cp.multiple==true)
				{
					// alert(JSON.stringify(this.state.options));
					if(this.state.selectValue)
					{
						if(typeof this.state.selectValue == 'string')
						{
							realSelectValue = this.state.selectValue.split(",");
						}
						
					}
					else
					{
						realSelectValue = [];
					}
					
				}
				
				
				 
				return  <div>   {this.props.editable!==false ? <Select 
				
				defaultValue={realSelectValue}
				value = {realSelectValue==''?null:realSelectValue}
				  mode={this.props.component.cp.multiple==true?'multiple':''}
				//multipleLimit={this.props.component.cp.multipleLimit}
				multiple={this.props.component.cp.multiple===true}
				//allowCreate={this.props.component.cp.allowCreate===true}
				
				 allowClear={true} 
				 //onDropdownVisibleChange={this.visibleChange } 
				 
				  placeholder={this.props.component.cp.placeholder?this.props.component.cp.placeholder:'请选择'}
				// onClear={()=>{this.state.selectValue="";this.valueChange("");this.refresh();}}
				 onChange={this.valueChange} style={{'width':'100%'}} 
				 options={this.state.options}
				 > 
                
            </Select>
			: 
					<div className={`kee-static-div`} >
					{
						this.props.component.cp.filter?<div  >{this.props.component.htmlField} </div>
						:<pre >
					        {this.state.selectTitle}
					        </pre>
					} 
					</div>
				}
			</div>
			}
			
			
			renderFsRadio(){
				return  <div>   {this.props.editable!==false ?  <Radio.Group
				 onChange={(e)=>{if(this.props.debug) return ;this.state.value=e.target.value;this.valueChange(e.target.value)}} 
				value={this.state.value}      >
       
				{
					this.state.options && Array.isArray(this.state.options) && this.state.options.map((item,index)=>{
						return <div  key={index}> <Radio style={{lineHeight:'30px',display:(window.isReport?'block':(this.props.component.style.display))}} value={item.value}>
							   {item.title}
							 </Radio>
							 {
							 	item.cardImg ? 
								 <div>
									<Image 
										src={`${window.fileUrl}/api/fs/getById?ids=${item.cardImg}`} 
										alt={item.cardImg}
										style={{margin: '10px 20px'}}
										width={52}
										height={52}
									/>
								</div> : ''
							 }
							 </div>
					})
				}
				
				 
				</Radio.Group>
				 
				 
			: 
					<div className={`kee-static-div`} >
					{
						this.props.component.cp.filter?<div  >{this.props.component.htmlField} </div>
						:<pre >
					        {this.state.selectTitle}
					        </pre>
					} 
					</div>
				}
			</div>
			}
			
			checkBoxValueChange=(checkedList)=>{
				
				if(this.props.debug)
				{
					return ;
				}
				
				 
				this.state.values = checkedList;
				if(this.props.component.name === "fs-checkbox") {
						var ids = "";
						for(var i = 0; i < checkedList.length; i++) {
							 {
								if(ids !== "")
									ids += ",";
								ids += checkedList[i];
							}
						}
						this.props.component.value = ids;
					}  
				 
				
				if(this.props.po)
				{
					this.setVueAttr(this.props.po, this.props.component.cp.field, this.props.component.value);
				}
				
				this.refresh();
				 
				// this.sendEvent("change");
				this.sendPageEvent("change",this.props.component.value);
				
				 
				 
			}
			
			renderFsCheckbox(){
				return  <div className={`${window.isReport?'ant-checkbox-block':(this.props.component.style.display=='block'?'ant-checkbox-block':'')}`}> {this.props.editable!==false ?   <div>
										<Checkbox.Group
											value={this.state.values}
											onChange={this.checkBoxValueChange}
										>
											{
												this.state.options && Array.isArray(this.state.options) &&this.state.options.map((item,idx)=>{
													return <div key={idx}>
														<Checkbox value={item.value}>
															{item.title}
														</Checkbox>
														{item.cardImg ? 
															<div>
															<Image 
																src={`${window.fileUrl}/api/fs/getById?ids=${item.cardImg}`} 
																alt={item.cardImg}
																style={{margin: '10px 20px'}}
																width={52}
																height={52}
															/>
														</div> : ''}
													</div>
												})
											}
										</Checkbox.Group>
									</div>
								
						
					// this.state.options.map((item,index)=>{
					// 	return <div     key={item.id} style={{'marginRight':'30px',display: 'inlineBlock',width: this.props.component.cp.optionWidth?this.props.component.cp.optionWidth+'px':'auto'}} >
					// 	    <label className={`el-checkbox `} onClick={()=>{this.check(item)}} >
					// 	        <span  className={`el-checkbox__input ${item.xuanzhong?'is-checked':''}`} >
					// 	            <span className={`el-radio__inner`} >
					// 	            </span>
					// 	        </span>
					// 	        <span className={`el-checkbox__label`} style={{ paddingLeft:'0px',letterSpacing:'0px',fontWeight:' 400'}}>
					// 	        {item.title} 
					// 	        </span>
					// 	    </label>
					// 	</div>
						 
						
					// })
				
			: 
					<div className={`kee-static-div`} >
					{
						this.props.component.cp.filter?<div  >{this.props.component.htmlField} </div>
						:<pre >
					        {this.state.selectTitle}
					        </pre>
					} 
					</div>
				}
			</div>
			}
			
			displayRender(label) {
			  //return label[label.length - 1];
			  return label.join('/');
			}
			renderFsCascader(){
				return  <div> 
				 
				{this.props.editable!==false ?(window.isMobile?<div></div> : <Cascader options={this.props.component.name === 'fs-cascader' ? this.state.options : this.listOptionsArray} 
								 
				 
				changeOnSelect={true} 
				expandTrigger="hover"
				displayRender = {this.displayRender}
				value={this.state.cascaderValue} 
				size="medium" 
				onChange={this.valueChange} 
				 
				  placeholder={this.props.component.cp.placeholder?this.props.component.cp.placeholder:'请选择'}>
                </Cascader> 
			)
			:  <div className={`kee-static-div`} >
					{
						this.props.component.cp.filter?<div  >{this.props.component.htmlField} </div>
						: 
					      <div>  {this.state.selectTitle}</div>
					       
					} 
					</div>
				}
			</div>
			}
			
			  // componentWillReceiveProps(nextProps){
					// this.state.value = nextProps.component.value;
					// this.refresh();
			  // }
			
		
  render(){
	  if(this.props.component.name=='fs-select')
	  {
		  return this.renderFsSelect();
	  }
	  
	  if(this.props.component.name=='fs-radio')
	  {
	  	  return this.renderFsRadio();
	  }
	  
	  if(this.props.component.name=='fs-checkbox')
	  {
	  	  return this.renderFsCheckbox();
	  }
	  
	  if(this.props.component.name === 'fs-cascader' || this.props.component.name === 'fs-cascading')
	  {
	  	  return this.renderFsCascader();
	  }
	  
	  return null;
	  
	 }
 }
